import { createSelector } from 'reselect';
import { getWishId } from 'lib/commonSelectors';
import { getEditedWishId } from 'store/editWish/selectors';
import { getWishesFiltersChecked } from 'store/wishes/selectors';

export const getFirebase = state => state.firebase;

export const getData = createSelector(getFirebase, firebase => firebase.data);
export const getOrdered = createSelector(getFirebase, firebase => firebase.ordered);
export const getAdmins = createSelector(getData, data => data.admins);
export const getAuth = createSelector(getFirebase, firebase => firebase.auth);

export const getUserId = createSelector(getAuth, auth => auth.uid)

export const getIsAdmin = createSelector(
  getAdmins,
  getAuth,
  (admins, auth) => admins && auth && auth.uid && admins[auth.uid] === true
);

export const getWishes = createSelector(getData, data => data.wishes);

export const getOrderedWishes = createSelector(getOrdered, ordered => ordered.wishes);

export const getVisibleOrderedWishes = createSelector(
  getIsAdmin,
  getOrderedWishes,
  (isAdmin, wishes) => isAdmin
    ? wishes
    : wishes
      && Array.isArray(wishes)
      && wishes.filter(wish => wish.value.visible)
);

export const getVisibleOrderedFilteredWishes = createSelector(
  getVisibleOrderedWishes,
  getWishesFiltersChecked,
  (wishes, checked) => {
    const showFromIsrael = checked.indexOf('showFromIsrael') !== -1;
    const showFromGermany = checked.indexOf('showFromGermany') !== -1;

    return wishes
      && Array.isArray(wishes)
      && wishes.filter(wish =>
        (wish.value.from === "israel" && showFromIsrael) ||
        (wish.value.from === "germany" && showFromGermany))
  }
);

export const getWish = createSelector(
  getWishes,
  getWishId,
  (wishes, wishId) => wishes && wishes[wishId]
);

export const getWillBuys = createSelector(getData, data => data.willBuys);

export const getWillBuy = createSelector(
  getWillBuys,
  getWishId,
  (willBuys, wishId) => willBuys && willBuys[wishId]
);

export const getWhoWillBuy = createSelector(
  getWillBuy,
  willBuy => !!willBuy ? willBuy.userId : null
);

export const getWishIdsIWillBuy = createSelector(
  getWillBuys,
  getUserId,
  (willBuys, userId) =>
    willBuys && Object.keys(willBuys).filter(wishId => {
      const willBuy = willBuys[wishId];
      return willBuy && willBuy.userId === userId;
    })
);

export const getEditedWish = createSelector(
  getWishes,
  getEditedWishId,
  (wishes, wishId) => wishes && wishes[wishId]
);

export const getWishesStats = createSelector(
  getOrderedWishes,
  getWillBuys,
  (wishes, willBuys) => {
    const stats = {
      sumPriceEuro: 0,
      sumPriceILS: 0,
      numInEuro: 0,
      numInILS: 0,

      sumPriceEuroWillBuys: 0,
      sumPriceILSWillBuys: 0,
      numInEuroWillBuys: 0,
      numInILSWillBuys: 0,

      sumPriceEuroFree: 0,
      sumPriceILSFree: 0,
      numInEuroFree: 0,
      numInILSFree: 0,
    };

    wishes
      .map(wish => ({ wish: wish.value, id: wish.key }))
      .forEach(({ wish, id }) => {
        const willBuy = !!willBuys && willBuys[id] !== undefined && willBuys[id] !== null;

        if (wish.currency === 'euro') {
          stats.numInEuro += 1;
          stats.sumPriceEuro += wish.price;

          if (willBuy) {
            stats.numInEuroWillBuys += 1;
            stats.sumPriceEuroWillBuys += wish.price;
          } else {
            stats.numInEuroFree += 1;
            stats.sumPriceEuroFree += wish.price;
          }
        }

        if (wish.currency === 'ils') {
          stats.numInILS += 1;
          stats.sumPriceILS += wish.price;

          if (willBuy) {
            stats.numInILSWillBuys += 1;
            stats.sumPriceILSWillBuys += wish.price;
          } else {
            stats.numInILSFree += 1;
            stats.sumPriceILSFree += wish.price;
          }
        }
      });

    return stats;
  }
);



// WEBPACK FOOTER //
// ./src/store/firebase/selectors.js